import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyAeRSpUGZNM8mVTUxARY-FzEZmJCBZhcLY",
  authDomain: "realestate-84813.firebaseapp.com",
  projectId: "realestate-84813",
  storageBucket: "realestate-84813.firebasestorage.app",
  messagingSenderId: "17629542370",
  appId: "1:17629542370:web:45a12286efb028133b6bbb",
  measurementId: "G-FDK1NKJZ9L"
};

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app); // optional

export const auth = getAuth(app);
export const db = getFirestore(app);
export { analytics };
export default app;
